export const createAction = (type: string, payload: any = undefined) => ({
    type,
    payload,
});